import { combineReducers } from "redux";
import quotaReducer from "./quotaReducer";
import createSite from "./siteReducer";
import response from "./fetchReducer";
import userReducer from "./userReducer";
import Step2ValidationResult from "./StepsValidationReducer/Step2ValidationResult";
//import dimensionReducer from "./DimensionReducer/dimensionReducer"
import wizardReducer from "./StepsValidationReducer/WizardReducer";
import Step1ValidationResult from "./StepsValidationReducer/Step1ValidatornResult";
import securityReducer from "./securityReducer";
import appReducer from "./appReducer";

export default combineReducers({
  quotas: quotaReducer,
  newSite: createSite,
  response: response,
  step1Validation: Step1ValidationResult,
  step2Validation: Step2ValidationResult,
  // dimension : dimensionReducer,
  wizard: wizardReducer,
  user: userReducer,
  security: securityReducer,
  app: appReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js